export class Tuple<TFirst, TSecond> {
    constructor(public first: TFirst, public second: TSecond) { }
}